import "./App.css";
import { useState, useEffect } from "react";
import { Amplify } from "aws-amplify";
import outputs from "./amplify_outputs.json";
import { signInWithRedirect, getCurrentUser } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import bannerImg from "./IT-virtual-assistant-banner.png";

Amplify.configure(outputs);

function App() {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [customState, setCustomState] = useState(null);

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload }) => {
      switch (payload.event) {
        case "signInWithRedirect":
          getUser();
          break;
        case "signInWithRedirect_failure":
          setError("An error has ocurred during the OAuth flow.");
          break;
        case "customOAuthState":
          setCustomState(payload.data);
          break;
      }
    });

    getUser();

    return unsubscribe;
  }, []);

  const getUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
      return currentUser;
    } catch (error) {
      console.error(error);
      console.log("Not signed in");
    }
  };

  const verifyLoggedIn = async () => {
    const currentUser = await getUser();
    if (!user && !currentUser) {
      await signInWithRedirect({
        provider: {
          custom: "DigitalMaximusITChatAzureSSO",
        },
      });
    }
  };

  useEffect(() => {
    verifyLoggedIn();
  }, []);

  if (!user) {
    return null;
  }

  return (
    <div id="container">
      <div id="header" className="contentBox header-wrapper">
        <div>
          <img src={bannerImg} alt="Maximus" />
        </div>
      </div>
      <div className="contentBox info-box">
        <p style={{ fontFamily: "Arial", fontSize: "14px" }}>
          Welcome to the IT Virtual Assistant.
          <br />
          <br />
          You can use the chat box below to ask questions about common issues
          including resetting your password, setting up Multi-factor
          Authentication or VPN, ordering a new computer and more.
          <br />
          <br />
          To start a new conversation, type “Hello” in the chat box to get help
          from our virtual assistant, which uses natural language processing
          (NLP) and machine learning (ML) to answer your questions.
          <br />
          <br />
          If the IT Virtual Assistant cannot answer your question, you can open
          a ticket in the{" "}
          <a
            href="https://maximus.service-now.com/esc"
            title="IT Service Desk Portal"
          >
            IT Service Desk Portal
          </a>{" "}
          or call our IT Service Desk (available 24/7) at 888.349.7762.
        </p>
      </div>
      <script type="text/javascript" src="/files/jquery.js?view=1"></script>
      <div id="footer">
        Copyright © 2002-2025 BeyondTrust Corporation. Redistribution
        Prohibited. All Rights Reserved.
        <div>
          <a
            id="powered_by_text"
            href="https://www.beyondtrust.com/"
            class="inverse"
            target="_blank"
            rel="noopener"
          >
            BeyondTrust Remote Support
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
